import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// material-ui/ core components
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle';
import withStyles from '@material-ui/core/styles/withStyles';
// material-ui icons
import Edit from '@material-ui/icons/Edit';
import Add from '@material-ui/icons/Add';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
import Button from 'components/UI/CustomButtons/Button';
// global variables
import { exchangeRateStatus } from 'config';
// our components
import RouterContext from 'helpers/routerContext';
import { formatRoute } from 'react-router-named-routes';
import { EXCHANGE_RATE } from 'routes/paths';
import dateFormat from 'helpers/dateHelper';
import WithPermission from '../../User/WithPermission';

class ExchangeRateDetail extends React.Component {
  static contextType = RouterContext;

  /**
   * @description
   * Redirect to exchange_rate/create route.
   */
  handleCreate = () => {
    const history = this.context;
    history.push(EXCHANGE_RATE.CREATE);
  };

  /**
   * @description
   * Redirect to exchange_rate/update route.
   */
  handleUpdate = () => {
    const history = this.context;
    const { data } = this.props;
    history.push(formatRoute(EXCHANGE_RATE.UPDATE, { id: data.id }));
  };

  /**
   * @description
   * Render Status.
   *
   * @param {Object} node - An exchange rate.
   * @returns {*} Status.
   */
  renderStatus = node => {
    const { classes, t } = this.props;
    let status;

    switch (node.status) {
      case exchangeRateStatus.DISABLED:
        status = <p>{t('exchange_rate.list.status.disabled')}</p>;
        break;
      case exchangeRateStatus.ENABLED:
        status = <p>{t('exchange_rate.list.status.enabled')}</p>;
        break;
      default:
        status = '';
        break;
    }
    return <div className={classes.infoStatusAndReview}>{status}</div>;
  };

  render() {
    const { classes, t, data } = this.props;
    return (
      <div className={classes.pageContainer}>
        <GridContainer>
          <GridItem xs={12} sm={6}>
            <h6>{t('exchange_rate.details.title')}</h6>
            <h3 className={classes.title}>
              {data && `${data.currencyFrom} >> ${data.currencyTo}`}
            </h3>
          </GridItem>
          <GridItem xs={12} sm={6}>
            <GridContainer justify="flex-end">
              <GridItem>
                <WithPermission allowPermissions={['change_exchangerate']}>
                  <Button
                    color="primary"
                    onClick={this.handleUpdate}
                    justIcon
                    id="exchangeRate-edit"
                  >
                    <Edit />
                  </Button>
                </WithPermission>
                <WithPermission allowPermissions={['add_exchangerate']}>
                  <Button
                    color="success"
                    justIcon
                    onClick={this.handleCreate}
                    id="exchangeRate-create"
                  >
                    <Add />
                  </Button>
                </WithPermission>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>

        <div className={classes.contentContainer}>
          <GridContainer>
            {data && data.createdBy && (
              <GridItem xs={12} sm={6}>
                <h6>{t('exchange_rate.details.createdBy')}</h6>
                <p>
                  {data.createdBy.fullname} - {dateFormat(data.createdOn, t)}
                </p>
              </GridItem>
            )}
            {data && data.updatedBy && (
              <GridItem xs={12} sm={6}>
                <h6>{t('exchange_rate.details.updatedBy')}</h6>
                <p>
                  {data.updatedBy.fullname} - {dateFormat(data.updatedOn, t)}
                </p>
              </GridItem>
            )}
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={6}>
              <h6>{t('exchange_rate.details.startDate')}</h6>
              <p>{data && data.startDate}</p>
            </GridItem>
            <GridItem xs={12} sm={6}>
              <h6>{t('exchange_rate.details.rate')}</h6>
              <p>{data && data.rate}</p>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={6}>
              <h6>{t('exchange_rate.details.endDate')}</h6>
              <p>{data && data.endDate}</p>
            </GridItem>
            <GridItem xs={12} sm={6}>
              <h6>{t('exchange_rate.details.status')}</h6>
              {this.renderStatus(data)}
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

/**
 * ExchangeRateDetail PropTypes
 * @param data - processor rule
 * @param classes - styles
 * @param t - prop from HOC with string translations
 */
ExchangeRateDetail.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
  data: PropTypes.instanceOf(Object),
};

ExchangeRateDetail.defaultProps = {
  data: undefined,
};

// to fix: The withStyles HOC set contextTypes to a children component
const ExchangeRateWrapper = props => <ExchangeRateDetail {...props} />;

export default withTranslation()(
  withStyles(extendedTablesStyle)(ExchangeRateWrapper),
);
